import React, { useRef } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { Link } from 'react-router-dom';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube, FaUser, FaInstagram } from 'react-icons/fa';

import { Figure } from 'react-bootstrap';

import icon1 from './../../assets/images/Services12.jpeg'; // Adjust the path as necessary
import icon2 from './../../assets/images/zza1.png';
import icon3 from './../../assets/images/zza2.png';

import icon4 from './../../assets/images/shipping-safty.png';
import icon5 from './../../assets/images/NavalA1.png';
import icon6 from './../../assets/images/SHIPREGISTRY.png';
import icon7 from './../../assets/images/fishing-img.png';
import icon8 from './../../assets/images/forms-img.png';
// import icon9 from './../../assets/images/audit-accreditation-img.png';
import icon9 from './../../assets/images/AudiA1.png';
import icon10 from './../../assets/images/Welfare-S.png';

import logo1 from './../../assets/images/dot_logo.png';
import logo2 from './../../assets/images/IMO-2-e1606733903963.png';

import la from './../../assets/images/left-arrow.svg';
import ra from './../../assets/images/right-arrow.svg';


function ServiceSlider() {
  const nextRef = useRef(null);
  const prevRef = useRef(null);

  const cardData = [
    {
      icon: icon1,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardReadmore: "/​",
      cardTitle: "Seafarer Services",
      link: '/services?section=seafarer-overview'
    },
    {
      icon: icon2,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardReadmore: "/​",
      cardTitle: "Small Vessel Safety",
      link: '/services?section=vessels-overview'
    },
    {
      icon: icon3,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardReadmore: "/​",
      cardTitle: "Sea Watch & Response",
      link: '/services?section=watch-overview'
    },
    {
      icon: icon4,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardReadmore: "/​",
      cardTitle: "Shipping Safety",
      link: '/services?section=shipping-overview'
    },
    {
      icon: icon5,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardReadmore: "/​",
      cardTitle: "Naval Architecture",
      link: '/services?section=naval-overview'
    },
    {
      icon: icon6,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardReadmore: "/​",
      cardTitle: "Ship Registry",
      link: '/services?section=registry-overview'
    },
    {
      icon: icon7,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardReadmore: "/​",
      cardTitle: "Fishing",
      link: '/services?section=fishing-overview'
    },
    {
      icon: icon8,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardReadmore: "/​",
      cardTitle: "Forms",
      link: '/services?section=forms-all'
    },
    {
      icon: icon9,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardReadmore: "/​",
      cardTitle: "Audit And Accreditation",
      link: '/services?section=audit-overview'
    },
    {
      icon: icon10,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardReadmore: "/​",
      cardTitle: "Seafarer Welfare",
      link: '/welfare'
    },


  ];

  return (
    <>


      <div className="latest-marine-list w-100 position-relative">
        <Swiper
          modules={[Navigation]}

          navigation={{
            nextEl: ".custom-new-next",  // Custom next button
            prevEl: ".custom-new-prev",  // Custom prev button
          }}
          breakpoints={{
            320: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1200: {
              slidesPerView: 5,
              spaceBetween: 40,
            },
          }}
          onInit={(swiper) => {
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          className="mySwiper card-list"
        >

          {cardData.map((card, index) => (
            <SwiperSlide key={index}>
              <div className="latest-marine-card w-100" key={index}>
                <div className="card-img mb-3 rounded-2 overflow-hidden">
                  <Link to={card.link}><img src={card.icon} alt="Profile" className="img-fluid w-100" /></Link>
                  {/* <div className="card-share">
                    <a href="#" className="btn-share"><i className="bi bi-share"></i></a>
                    <ul>

                      <li><a href='#'><FaFacebookF /></a></li>
                      <li><a href='#'><FaTwitter /></a></li>
                      <li><a href='#'><FaLinkedinIn /></a></li>
                      <li><a href='#'><FaInstagram /></a></li>
                      <li><a href='#'><FaYoutube /></a></li>

                    </ul>
                  </div> */}
                </div>

                <h4 className="title mt-3 text-wrap text-center font-20 font-600">{card.cardTitle} </h4>
                <div className="text-center">
                  <a href={card.cardReadmore} className="title text-wrap text-center font-16 font-400 fst-italic text-green-38B652 text-decoration-none d-none">Read More</a>
                </div>


              </div>
            </SwiperSlide>

          ))}


        </Swiper>
        <div className="latest-marine-navigation">
          {/* Custom Navigation Buttons */}
          <button ref={prevRef} className="custom-new-prev">
            <img src={la} alt="" className="" />
          </button>
          <button ref={nextRef} className="custom-new-next">
            <img src={ra} alt="" className="" />
          </button>
        </div>
      </div>



    </>
  )
}

export default ServiceSlider;